import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M8 20v-16l-5 5","key":"svg-0"}],["path",{"d":"M18 20v-16l-5 5","key":"svg-1"}]]

/**
 * IconNumber11
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItbnVtYmVyLTExIgo+CiAgPHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIiAvPgogIDxwYXRoIGQ9Ik04IDIwdi0xNmwtNSA1IiAvPgogIDxwYXRoIGQ9Ik0xOCAyMHYtMTZsLTUgNSIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/number-11
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconNumber11 = createReactComponent('outline', 'number-11', 'Number11', __iconNode);

export default IconNumber11;